<template>
  <div v-loading="loading" class="page-stack">
    <section class="hero-panel">
      <div>
        <p class="eyebrow">TODAY'S DELIVERY PULSE</p>
        <h2>语音触达链路已就绪</h2>
        <p>当前阶段只启用 AI 语音供应商，跨类型自动降级保持关闭。</p>
      </div>
      <div class="hero-health">
        <div class="pulse-ring"><i class="el-icon-microphone"></i></div>
        <div>
          <span>AI Voice Provider</span>
          <strong>{{ providerState }}</strong>
        </div>
      </div>
    </section>

    <section class="stat-grid">
      <article v-for="card in statCards" :key="card.key" class="stat-card" :class="card.tone">
        <div class="stat-icon"><i :class="card.icon"></i></div>
        <div>
          <span>{{ card.label }}</span>
          <strong>{{ stats[card.key] || 0 }}</strong>
          <small>{{ card.hint }}</small>
        </div>
      </article>
    </section>

    <section class="dashboard-grid">
      <article class="surface-card recent-card">
        <div class="section-head">
          <div>
            <p class="eyebrow">RECENT ACTIVITY</p>
            <h3>最近发送记录</h3>
          </div>
          <el-button type="text" @click="$router.push('/messages')">查看全部 <i class="el-icon-right"></i></el-button>
        </div>
        <el-table :data="recentMessages" class="clean-table" empty-text="暂无发送记录">
          <el-table-column prop="messageId" label="消息 ID" min-width="150">
            <template slot-scope="{ row }">
              <button class="text-link mono" @click="$router.push(`/messages/${row.messageId}`)">
                {{ row.messageId }}
              </button>
            </template>
          </el-table-column>
          <el-table-column prop="receiverMasked" label="接收人" min-width="130" />
          <el-table-column prop="status" label="状态" width="120">
            <template slot-scope="{ row }"><status-tag :status="row.status" /></template>
          </el-table-column>
          <el-table-column prop="createdAt" label="创建时间" min-width="170">
            <template slot-scope="{ row }">{{ formatDate(row.createdAt) }}</template>
          </el-table-column>
        </el-table>
      </article>

      <article class="surface-card guard-card">
        <div class="section-head">
          <div>
            <p class="eyebrow">SAFETY GUARDS</p>
            <h3>上线保护</h3>
          </div>
          <span class="guard-score">4 / 4</span>
        </div>
        <ul class="guard-list">
          <li><i class="el-icon-check"></i><div><strong>跨通道降级关闭</strong><span>当前只生成候选，不自动发送</span></div></li>
          <li><i class="el-icon-check"></i><div><strong>供应商凭据脱敏</strong><span>页面不返回 Token 与 Secret</span></div></li>
          <li><i class="el-icon-check"></i><div><strong>回调幂等基线</strong><span>providerCode + callId 唯一</span></div></li>
          <li><i class="el-icon-check"></i><div><strong>手工发送关闭</strong><span>本地可按配置显式启用</span></div></li>
        </ul>
      </article>
    </section>
  </div>
</template>

<script>
import { getDashboard, getMessages, getProviders } from '../api/admin'
import StatusTag from '../components/StatusTag.vue'

export default {
  name: 'DashboardView',
  components: { StatusTag },
  data () {
    return {
      loading: true,
      stats: {},
      recentMessages: [],
      providers: [],
      statCards: [
        { key: 'totalMessages', label: '今日发送', hint: '全部受理请求', icon: 'el-icon-s-promotion', tone: 'blue' },
        { key: 'successMessages', label: '接通成功', hint: 'ANSWERED', icon: 'el-icon-phone-outline', tone: 'green' },
        { key: 'waitingCallbacks', label: '等待回调', hint: 'Accepted / Sending', icon: 'el-icon-time', tone: 'amber' },
        { key: 'failureMessages', label: '最终失败', hint: '可生成降级候选', icon: 'el-icon-circle-close', tone: 'red' },
        { key: 'callbackExceptions', label: '回调异常', hint: '需要人工排查', icon: 'el-icon-warning-outline', tone: 'violet' },
        { key: 'fallbackCandidates', label: '降级候选', hint: '不会自动跨通道', icon: 'el-icon-connection', tone: 'slate' }
      ]
    }
  },
  computed: {
    providerState () {
      if (!this.providers.length) return '尚未配置'
      return this.providers.some(item => item.enabled) ? '已启用' : '安全停用'
    }
  },
  async created () {
    try {
      const [stats, messages, providers] = await Promise.all([
        getDashboard(),
        getMessages({ page: 1, size: 5 }),
        getProviders()
      ])
      this.stats = stats
      this.recentMessages = messages.items
      this.providers = providers
    } catch (error) {
      this.$message.error('概览数据加载失败')
    } finally {
      this.loading = false
    }
  },
  methods: {
    formatDate (value) {
      return value ? value.replace('T', ' ') : '—'
    }
  }
}
</script>

